import {
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
} from '@mui/material';
import { CustomTableCell } from '../../index';
import { formatISOToPHT } from '../../../utilities/date';

export const VoluntaryWorksComponent = (props) => {
  return (
    <Box sx={{ mb: 3, padding: '12px' }}>
      <TableContainer
        sx={{
          height: '100%',
          width: '100%',
          overflow: 'auto',
          padding: '12px',
        }}
      >
        <Table
          sx={{
            width: '100%',
          }}
        >
          <TableHead>
            <TableRow>
              <CustomTableCell value="Name of Organization" />
              <CustomTableCell value="Address" />
              <CustomTableCell value="Number of Hours" />
              <CustomTableCell value="Start Date" />
              <CustomTableCell value="End Date" />
            </TableRow>
          </TableHead>
          {props.empVolWork?.map((volWork) => (
            <TableRow key={volWork._id}>
              <TableCell> {volWork.organizationname} </TableCell>
              <TableCell> {volWork.address} </TableCell>
              <TableCell> {volWork.hours} </TableCell>
              <TableCell> {formatISOToPHT(volWork.startdate)} </TableCell>
              <TableCell> {formatISOToPHT(volWork.enddate)} </TableCell>
            </TableRow>
          ))}
        </Table>
      </TableContainer>
    </Box>
  );
};
